// extracted by mini-css-extract-plugin
export default {"container":"InputLabel--container--ee24e3","required":"InputLabel--required--292c57","fullBorder":"InputLabel--fullBorder--1db158"};